module.exports = __webpack_public_path__ + "img/Under-Construction-th.2134bf4.png";